import { render, staticRenderFns } from "./HighlightWrapper.vue?vue&type=template&id=4620ed8c&lang=pug"
import script from "./HighlightWrapper.vue?vue&type=script&lang=js"
export * from "./HighlightWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports